export default __webpack_public_path__ + "static/media/img-2.383e4f1e.png";